export class AppRouters {
  // *********** ERRORS ***********
  static readonly errors_404 = '/errors/404';
  static readonly errors_500 = '/errors/500';
  // *********** AUTH ***********
  static readonly dashboard_nfts = '/dashboard/nfts';

  static readonly auth_SignIn = '/auth/sign-in';
  static readonly auth_SignUp = '/auth/sign-up';
  static readonly auth_TwoSteps = '/auth/two-steps';
  static readonly auth_ForgotPassword = '/auth/forgot-password';
  static readonly auth_NewPassword = '/auth/new-password';
  static readonly auth_Components_Table = '/components/table';

  static readonly dashboard_productList = '/dashboard/product-list';

  static productList(inputType: string = 'financial'): string {
    return `${this.dashboard_productList}?type=${inputType.toLowerCase()}`;
  }
  //
  // static readonly dashboard_email = '/dashboard/email';
  // static readonly dashboard_details = '/dashboard/details';
  // static readonly dashboard_folders = '/dashboard/folders';
}
